const LangResetPassword = {
	"resetPassword._title": ["RESET PASSWORD", "កំណត់​លេខ​សម្ងាត់​ឡើង​វិញ"],
	"resetPassword.form.label._newPassword": ["New Password", "លេខ​សម្ងាត់​ថ្មី"],
	"resetPassword.form.label._confirmNewPassword": [
		"Confirm New Password",
		"បញ្ជាក់​លេខ​សម្ងាត់​ថ្មី",
	],
}

export default LangResetPassword



// WEBPACK FOOTER //
// ./src/resources/pages/LangResetPassword.js